<template >
  <div class="container-fluid bg-white" v-if="item">
    <div class="row">
      <div class="col-md-8 col-sm-12" style="padding-bottom:2em;">
        <h3 class="text-center">{{lesson.name}}</h3>
        <div v-if="item.videoUrl!=null">
          <div style>
            <h3>{{item.name}}</h3>
          </div>
          <div>
            <!-- <iframe width="100%" height="600" frameborder="0" src="https://www.youtube.com/embed/oYiT-vLjhC4" allowfullscreen></iframe> -->
            <iframe
              width="100%"
              height="600"
              v-if="item.videoUrl!=null && item.videoUrl!='' && item.videoUrl.toLowerCase().indexOf('youtube') != -1"
              v-bind:src="getYoutubeIframe(item.videoUrl)"
              frameborder="0"
              allowfullscreen
            ></iframe>
            <!-- <iframe width="560" height="315" v-if="item.videoUrl!=null && item.videoUrl!='' && item.videoUrl.toLowerCase().indexOf('youtube') != -1" v-bind:src="getYoutubeIframe(item.videoUrl)"  frameborder="0" allowfullscreen></iframe> -->
          </div>
        </div>
        <hr class="mb-5" />
      </div>
      <div class="col-md-4 col-sm-12" style="background: #f7f7f7;padding: 0 0 0 1em;">
        <div class="bg-white">
          <h3>Up Next</h3>
            <div class="pl-4">
              <div class="row">
                <div class="col-md-4">
                  <div>
                    <a href="single.html">
                        <img style="width: 100%;" src="https://img.youtube.com/vi/6yeK9Or8T08/1.jpg" alt="">
                        <!-- <iframe
                          width="210"
                          height="120"
                          frameborder="0"
                          src="https://www.youtube.com/embed/oYiT-vLjhC4"
                          allowfullscreen
                        ></iframe> -->
                    </a>
                    
                  </div>
                </div>
                <div class="col-md-8">
                              <a href="single.html">Nullam interdum metus</a>
                      <p class="author">
                        <a href="#" class="author">John Maniya</a>
                      </p>
                      <p class="views">xxx</p>
                </div>
            </div>
            <hr/>
          </div>
          <!-- <ul>
            <li v-if="item.files!=null && item.files.length>0">
              <div>
                <div
                  v-for="(file, index) in item.files"
                  v-bind:key="file.id"
                  v-if="validFile(file)"
                >
                  <a v-bind:href="file.fileUrl" target="_blank">
                    <i class="fas fa-download"></i>
                    {{file.fileName}}
                  </a>
                  <i
                    class="fas fa-trash text-danger ml-2"
                    @click="_deleteTopicFile(topic,item, file, index)"
                  ></i>
                </div>
              </div>
            </li>
          </ul>
          <input type="file" :ref="'file_' + item.id" @change="uploadFile(topic, item)" />
          <div
            v-if="item.files==null || (item.files!=null && item.files.length==0) "
            class="my-2 alert alert-info"
          >Та {{item.name}} агуулгын материалыг /ppt, pptx, docx, doc болон pdf файл/ оруулах боломжтой.</div>

          <div class="progress" v-if="item.uploading">
            <div
              class="progress-bar"
              role="progressbar"
              v-bind:style="{ width: item.uploadPercent + '%' }"
              aria-valuemin="0"
              aria-valuemax="100"
            >{{item.uploadPercent.toFixed()}}%</div>
          </div>

          <div class="btn btn-primary btn-sm" @click="openSubContentModal">нэмэх</div>
          <div>
            <ul v-if="itemDetails!=null && itemDetails.length>0">
              <li v-for="subdetail in itemDetails">
                {{subdetail.data().name}}({{subdetail.data().numberOfUnderstand}})
                <i
                  class="fas fa-edit text-danger"
                  @click="_editSub(subdetail)"
                ></i>
              </li>
            </ul>
          </div>-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const fb = require("../../../firebaseConfig.js");
import { mapState } from "vuex";
import moment from "moment";
import firebase from "firebase";
import LessonHeader from "../lesson/ILessonHeader";

export default {
  name: "IVideoFrame",
  components: {
    LessonHeader,
  },
  data() {
    return {
      lesson: null,
      topic: null,
      item: null,
      types: [],
      selectedType: null,
      content: {},
      itemDetails: [],
      selectedTopic: null,

      display: 0,
      topicBucket: "lessonTopicFiles/",
      sub: {
        name: null,
      },
    };
  },
  methods: {
    _getQA() {
      fb.db
        .collection("schools/" + this.schoolId + "/lessons")
        .doc(this.lessonId)
        .get()
        .then((doc) => {
          let lesson = doc.data();
          lesson.id = doc.id;
          this.lesson = lesson;
          doc.ref
            .collection("topics")
            .doc(this.topicId)
            .get()
            .then((tdoc) => {
              if (tdoc.exists) {
                let topic = tdoc.data();
                topic.id = tdoc.id;
                this.topic = topic;

                tdoc.ref
                  .collection("details")
                  .doc(this.contentId)
                  .onSnapshot((cdoc) => {
                    if (cdoc.exists) {
                      let item = cdoc.data();
                      item.id = cdoc.id;
                      item.uploading = false;
                      item.uploadPercent = 0;
                      if (!item.startDayStr) item.startDayStr = null;
                      if (!item.endDayStr) item.endDayStr = null;
                      if (!item.startDay) item.startDay = null;
                      if (!item.endDay) item.endDay = null;

                      this.item = item;
                      cdoc.ref
                        .collection("subdetails")
                        .orderBy("createdAt", "desc")
                        .onSnapshot((docs) => {
                          if (docs != null && !docs.empty) {
                            this.itemDetails = docs.docs;
                          }
                        });
                    }
                  });
              }
            });
        });

      fb.db
        .collection("ContentTypes")
        .get()
        .then((querySnapshot) => {
          this.types = [];
          querySnapshot.forEach((doc) => {
            let object = doc.data();
            object.id = doc.id;
            object.content = [];
            this.types.push(object);
          });
        });
    },

    getYoutubeId(url) {
      const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      const match = url.match(regExp);

      return match && match[2].length === 11 ? match[2] : null;
    },
    getYoutubeIframe(url) {
      if (
        url != null &&
        url != "" &&
        url.toLowerCase().indexOf("youtube") != -1
      ) {
        var id = this.getYoutubeId(url);
        return "https://www.youtube.com/embed/" + id;
      }
      return null;
    },
  },
  computed: {
    ...mapState(["userProfile", "currentUser"]),
  },
  props: {
    schoolId: {
      required: true,
    },
    lessonId: {
      required: true,
    },
    topicId: {
      required: true,
    },
    contentId: {
      required: true,
    },
    showContainer: {
      required: false,
    },
  },
  created() {
    var _this = this;
    if (this.lessonId != null && this.lessonId != "") this._getQA();
  },
  filters: {
    formatDate(val) {
      if (!val) {
        return "-";
      }
      let date = val.toDate();
      return moment(date).format("MM/DD/YYYY HH:mm");
    },
  },
};
</script>

